const nationalities = [
    { value: "Afghan", label: "🇦🇫 Afghan" },
    { value: "Albanian", label: "🇦🇱 Albanian" },
    { value: "Algerian", label: "🇩🇿 Algerian" },
    { value: "American", label: "🇺🇸 American (USA)" },
    { value: "Andorran", label: "🇦🇩 Andorran" },
    { value: "Angolan", label: "🇦🇴 Angolan" },
    { value: "Argentinian", label: "🇦🇷 Argentinian" },
    { value: "Armenian", label: "🇦🇲 Armenian" },
    { value: "Australian", label: "🇦🇺 Australian" },
    { value: "Austrian", label: "🇦🇹 Austrian" },
    { value: "Azerbaijani", label: "🇦🇿 Azerbaijani" },
    { value: "Bahamian", label: "🇧🇸 Bahamian" },
    { value: "Bahraini", label: "🇧🇭 Bahraini" },
    { value: "Bangladeshi", label: "🇧🇩 Bangladeshi" },
    { value: "Barbadian", label: "🇧🇧 Barbadian" },
    { value: "Belarusian", label: "🇧🇾 Belarusian" },
    { value: "Belgian", label: "🇧🇪 Belgian" },
    { value: "Belizean", label: "🇧🇿 Belizean" },
    { value: "Beninese", label: "🇧🇯 Beninese" },
    { value: "Bhutanese", label: "🇧🇹 Bhutanese" },
    { value: "Bolivian", label: "🇧🇴 Bolivian" },
    { value: "Bosnian", label: "🇧🇦 Bosnian" },
    { value: "Botswanan", label: "🇧🇼 Botswanan" },
    { value: "Brazilian", label: "🇧🇷 Brazilian" },
    { value: "British", label: "🇬🇧 British" },
    { value: "Bruneian", label: "🇧🇳 Bruneian" },
    { value: "Bulgarian", label: "🇧🇬 Bulgarian" },
    { value: "Burkinabé", label: "🇧🇫 Burkinabé" },
    { value: "Burundian", label: "🇧🇮 Burundian" },
    { value: "Cambodian", label: "🇰🇭 Cambodian" },
    { value: "Cameroonian", label: "🇨🇲 Cameroonian" },
    { value: "Canadian", label: "🇨🇦 Canadian" },
    { value: "Central African", label: "🇨🇫 Central African" },
    { value: "Chadian", label: "🇹🇩 Chadian" },
    { value: "Chilean", label: "🇨🇱 Chilean" },
    { value: "Chinese", label: "🇨🇳 Chinese" },
    { value: "Colombian", label: "🇨🇴 Colombian" },
    { value: "Comoran", label: "🇰🇲 Comoran" },
    { value: "Congolese", label: "🇨🇬 Congolese" },
    { value: "Costa Rican", label: "🇨🇷 Costa Rican" },
    { value: "Croatian", label: "🇭🇷 Croatian" },
    { value: "Cuban", label: "🇨🇺 Cuban" },
    { value: "Cypriot", label: "🇨🇾 Cypriot" },
    { value: "Czech", label: "🇨🇿 Czech" },
    { value: "Danish", label: "🇩🇰 Danish" },
    { value: "Djiboutian", label: "🇩🇯 Djiboutian" },
    { value: "Dominican", label: "🇩🇴 Dominican" },
    { value: "Dutch", label: "🇳🇱 Dutch" },
    { value: "Ecuadorean", label: "🇪🇨 Ecuadorean" },
    { value: "Egyptian", label: "🇪🇬 Egyptian" },
    { value: "Emirati", label: "🇦🇪 Emirati" },
    { value: "Equatorial Guinean", label: "🇬🇶 Equatorial Guinean" },
    { value: "Eritrean", label: "🇪🇷 Eritrean" },
    { value: "Estonian", label: "🇪🇪 Estonian" },
    { value: "Ethiopian", label: "🇪🇹 Ethiopian" },
    { value: "Fijian", label: "🇫🇯 Fijian" },
    { value: "Finnish", label: "🇫🇮 Finnish" },
    { value: "French", label: "🇫🇷 French" },
    { value: "Gabonese", label: "🇬🇦 Gabonese" },
    { value: "Gambian", label: "🇬🇲 Gambian" },
    { value: "Georgian", label: "🇬🇪 Georgian" },
    { value: "German", label: "🇩🇪 German" },
    { value: "Ghanaian", label: "🇬🇭 Ghanaian" },
    { value: "Greek", label: "🇬🇷 Greek" },
    { value: "Grenadian", label: "🇬🇩 Grenadian" },
    { value: "Guatemalan", label: "🇬🇹 Guatemalan" },
    { value: "Guinean", label: "🇬🇳 Guinean" },
    { value: "Guyanese", label: "🇬🇾 Guyanese" },
    { value: "Haitian", label: "🇭🇹 Haitian" },
    { value: "Honduran", label: "🇭🇳 Honduran" },
    { value: "Hungarian", label: "🇭🇺 Hungarian" },
    { value: "Icelander", label: "🇮🇸 Icelander" },
    { value: "Indian", label: "🇮🇳 Indian" },
    { value: "Indonesian", label: "🇮🇩 Indonesian" },
    { value: "Iranian", label: "🇮🇷 Iranian" },
    { value: "Iraqi", label: "🇮🇶 Iraqi" },
    { value: "Irish", label: "🇮🇪 Irish" },
    { value: "Israeli", label: "🇮🇱 Israeli" },
    { value: "Italian", label: "🇮🇹 Italian" },
    { value: "Jamaican", label: "🇯🇲 Jamaican" },
    { value: "Japanese", label: "🇯🇵 Japanese" },
    { value: "Jordanian", label: "🇯🇴 Jordanian" },
    { value: "Kazakh", label: "🇰🇿 Kazakh" },
    { value: "Kenyan", label: "🇰🇪 Kenyan" },
    { value: "Kuwaiti", label: "🇰🇼 Kuwaiti" },
    { value: "Kyrgyz", label: "🇰🇬 Kyrgyz" },
    { value: "Laotian", label: "🇱🇦 Laotian" },
    { value: "Latvian", label: "🇱🇻 Latvian" },
    { value: "Lebanese", label: "🇱🇧 Lebanese" },
    { value: "Liberian", label: "🇱🇷 Liberian" },
    { value: "Libyan", label: "🇱🇾 Libyan" },
    { value: "Lithuanian", label: "🇱🇹 Lithuanian" },
    { value: "Luxembourger", label: "🇱🇺 Luxembourger" },
    { value: "Malaysian", label: "🇲🇾 Malaysian" },
    { value: "Maldivian", label: "🇲🇻 Maldivian" },
    { value: "Mexican", label: "🇲🇽 Mexican" },
    { value: "Nepalese", label: "🇳🇵 Nepalese" },
    { value: "Nigerian", label: "🇳🇬 Nigerian" },
    { value: "Norwegian", label: "🇳🇴 Norwegian" },
    { value: "Pakistani", label: "🇵🇰 Pakistani" },
    { value: "Philippine", label: "🇵🇭 Philippine" },
    { value: "Polish", label: "🇵🇱 Polish" },
    { value: "Portuguese", label: "🇵🇹 Portuguese" },
    { value: "Russian", label: "🇷🇺 Russian" },
    { value: "South African", label: "🇿🇦 South African" },
    { value: "Sri Lankan", label: "🇱🇰 Sri Lankan" },
    { value: "Swedish", label: "🇸🇪 Swedish" },
    { value: "Swiss", label: "🇨🇭 Swiss" },
    { value: "Thai", label: "🇹🇭 Thai" },
    { value: "Turkish", label: "🇹🇷 Turkish" },
    { value: "Ukrainian", label: "🇺🇦 Ukrainian" },
    { value: "Vietnamese", label: "🇻🇳 Vietnamese" },
    { value: "Zimbabwean", label: "🇿🇼 Zimbabwean" }
]

const countries = [
    {
        value: "Afghanistan",
        label: "🇦🇫 Afghanistan",
    },
    {
        value: "Albania",
        label: "🇦🇱 Albania",
    },
    {
        value: "Algeria",
        label: "🇩🇿 Algeria",
    },
    {
        value: "Andorra",
        label: "🇦🇩 Andorra",
    },
    {
        value: "Angola",
        label: "🇦🇴 Angola",
    },
    {
        value: "Antigua and Barbuda",
        label: "🇦🇬 Antigua and Barbuda",
    },
    {
        value: "Argentina",
        label: "🇦🇷 Argentina",
    },
    {
        value: "Armenia",
        label: "🇦🇲 Armenia",
    },
    {
        value: "Australia",
        label: "🇦🇺 Australia",
    },
    {
        value: "Austria",
        label: "🇦🇹 Austria",
    },
    {
        value: "Azerbaijan",
        label: "🇦🇿 Azerbaijan",
    },
    {
        value: "Bahamas",
        label: "🇧🇸 Bahamas",
    },
    {
        value: "Bahrain",
        label: "🇧🇭 Bahrain",
    },
    {
        value: "Bangladesh",
        label: "🇧🇩 Bangladesh",
    },
    {
        value: "Barbados",
        label: "🇧🇧 Barbados",
    },
    {
        value: "Belarus",
        label: "🇧🇾 Belarus",
    },
    {
        value: "Belgium",
        label: "🇧🇪 Belgium",
    },
    {
        value: "Belize",
        label: "🇧🇿 Belize",
    },
    {
        value: "Benin",
        label: "🇧🇯 Benin",
    },
    {
        value: "Bhutan",
        label: "🇧🇹 Bhutan",
    },
    {
        value: "Bolivia",
        label: "🇧🇴 Bolivia",
    },
    {
        value: "Bosnia and Herzegovina",
        label: "🇧🇦 Bosnia and Herzegovina",
    },
    {
        value: "Botswana",
        label: "🇧🇼 Botswana",
    },
    {
        value: "Brazil",
        label: "🇧🇷 Brazil",
    },
    {
        value: "Brunei",
        label: "🇧🇳 Brunei",
    },
    {
        value: "Bulgaria",
        label: "🇧🇬 Bulgaria",
    },
    {
        value: "Burkina Faso",
        label: "��🇫 Burkina Faso",
    },
    {
        value: "Burundi",
        label: "🇧🇮 Burundi",
    },
    {
        value: "Cabo Verde",
        label: "🇨🇻 Cabo Verde",
    },
    {
        value: "Cambodia",
        label: "🇰🇭 Cambodia",
    },
    {
        value: "Cameroon",
        label: "🇨🇲 Cameroon",
    },
    {
        value: "United States",
        label: "🇺🇸 United States (USA)",
    },
    {
        value: "Canada",
        label: "🇨🇦 Canada",
    },
    {
        value: "Central African Republic",
        label: "🇨🇫 Central African Republic",
    },
    {
        value: "Chad",
        label: "🇹🇩 Chad",
    },
    {
        value: "Chile",
        label: "🇨🇱 Chile",
    },
    {
        value: "China",
        label: "🇨🇳 China",
    },
    {
        value: "Colombia",
        label: "🇨🇴 Colombia",
    },
    {
        value: "Comoros",
        label: "🇰🇲 Comoros",
    },
    {
        value: "Congo (Congo-Brazzaville)",
        label: "🇨🇬 Congo (Congo-Brazzaville)",
    },
    {
        value: "Congo (Congo-Kinshasa)",
        label: "🇨🇩 Congo (Congo-Kinshasa)",
    },
    {
        value: "Costa Rica",
        label: "🇨🇷 Costa Rica",
    },
    {
        value: "Croatia",
        label: "🇭🇷 Croatia",
    },
    {
        value: "Cuba",
        label: "🇨🇺 Cuba",
    },
    {
        value: "Cyprus",
        label: "🇨🇾 Cyprus",
    },
    {
        value: "Czech Republic",
        label: "🇨🇿 Czech Republic",
    },
    {
        value: "Denmark",
        label: "🇩🇰 Denmark",
    },
    {
        value: "Djibouti",
        label: "🇩🇯 Djibouti",
    },
    {
        value: "Dominica",
        label: "🇩🇲 Dominica",
    },
    {
        value: "Dominican Republic",
        label: "🇩🇴 Dominican Republic",
    },
    {
        value: "Ecuador",
        label: "🇪🇨 Ecuador",
    },
    {
        value: "Egypt",
        label: "🇪🇬 Egypt",
    },
    {
        value: "El Salvador",
        label: "🇸🇻 El Salvador",
    },
    {
        value: "Equatorial Guinea",
        label: "🇬🇶 Equatorial Guinea",
    },
    {
        value: "Eritrea",
        label: "🇪🇷 Eritrea",
    },
    {
        value: "Estonia",
        label: "🇪🇪 Estonia",
    },
    {
        value: "Eswatini",
        label: "🇿🇿 Eswatini",
    },
    {
        value: "Ethiopia",
        label: "🇪🇹 Ethiopia",
    },
    {
        value: "Fiji",
        label: "🇫🇯 Fiji",
    },
    {
        value: "Finland",
        label: "🇫🇮 Finland",
    },
    {
        value: "France",
        label: "🇫🇷 France",
    },
    {
        value: "Gabon",
        label: "🇬🇦 Gabon",
    },
    {
        value: "Gambia",
        label: "🇬🇲 Gambia",
    },
    {
        value: "Georgia",
        label: "🇬🇪 Georgia",
    },
    {
        value: "Germany",
        label: "🇩🇪 Germany",
    },
    {
        value: "Ghana",
        label: "🇬🇭 Ghana",
    },
    {
        value: "Greece",
        label: "🇬🇷 Greece",
    },
    {
        value: "Grenada",
        label: "🇬🇩 Grenada",
    },
    {
        value: "Guatemala",
        label: "🇬🇹 Guatemala",
    },
    {
        value: "Guinea",
        label: "🇬🇳 Guinea",
    },
    {
        value: "Guinea-Bissau",
        label: "🇬🇼 Guinea-Bissau",
    },
    {
        value: "Guyana",
        label: "🇬🇾 Guyana",
    },
    {
        value: "Haiti",
        label: "🇭🇹 Haiti",
    },
    {
        value: "Honduras",
        label: "🇭🇳 Honduras",
    },
    {
        value: "Hungary",
        label: "🇭🇺 Hungary",
    },
    {
        value: "Iceland",
        label: "🇮🇸 Iceland",
    },
    {
        value: "India",
        label: "🇮🇳 India",
    },
    {
        value: "Indonesia",
        label: "🇮🇩 Indonesia",
    },
    {
        value: "Iran",
        label: "🇮🇷 Iran",
    },
    {
        value: "Iraq",
        label: "🇮🇶 Iraq",
    },
    {
        value: "Ireland",
        label: "🇮🇪 Ireland",
    },
    {
        value: "Israel",
        label: "🇮🇱 Israel",
    },
    {
        value: "Italy",
        label: "🇮🇹 Italy",
    },
    {
        value: "Jamaica",
        label: "🇯🇲 Jamaica",
    },
    {
        value: "Japan",
        label: "🇯🇵 Japan",
    },
    {
        value: "Jordan",
        label: "🇯🇴 Jordan",
    },
    {
        value: "Kazakhstan",
        label: "🇰🇿 Kazakhstan",
    },
    {
        value: "Kenya",
        label: "🇰🇪 Kenya",
    },
    {
        value: "Kiribati",
        label: "🇰🇮 Kiribati",
    },
    {
        value: "Kuwait",
        label: "🇰🇼 Kuwait",
    },
    {
        value: "Kyrgyzstan",
        label: "🇰🇬 Kyrgyzstan",
    },
    {
        value: "Laos",
        label: "🇱🇦 Laos",
    },
    {
        value: "Latvia",
        label: "🇱🇻 Latvia",
    },
    {
        value: "Lebanon",
        label: "🇱🇧 Lebanon",
    },
    {
        value: "Lesotho",
        label: "🇱🇸 Lesotho",
    },
    {
        value: "Liberia",
        label: "🇱🇷 Liberia",
    },
    {
        value: "Libya",
        label: "🇱🇾 Libya",
    },
    {
        value: "Lithuania",
        label: "🇱🇹 Lithuania",
    },
    {
        value: "Luxembourg",
        label: "🇱🇺 Luxembourg",
    },
    {
        value: "Malaysia",
        label: "🇲🇾 Malaysia",
    },
    {
        value: "Maldives",
        label: "🇲🇻 Maldives",
    },
    {
        value: "Mexico",
        label: "🇲🇽 Mexico",
    },
    {
        value: "Moldova",
        label: "🇲🇩 Moldova",
    },
    {
        value: "Monaco",
        label: "🇲🇨 Monaco",
    },
    {
        value: "Mongolia",
        label: "🇲🇳 Mongolia",
    },
    {
        value: "Montenegro",
        label: "🇲🇪 Montenegro",
    },
    {
        value: "Morocco",
        label: "🇲🇦 Morocco",
    },
    {
        value: "Mozambique",
        label: "🇲🇿 Mozambique",
    },
    {
        value: "Myanmar",
        label: "🇲🇲 Myanmar",
    },
    {
        value: "Namibia",
        label: "🇳🇦 Namibia",
    },
    {
        value: "Nauru",
        label: "🇳🇷 Nauru",
    },
    {
        value: "Nepal",
        label: "🇳🇵 Nepal",
    },
    {
        value: "Netherlands",
        label: "🇳🇱 Netherlands",
    },
    {
        value: "New Zealand",
        label: "🇳🇿 New Zealand",
    },
    {
        value: "Nicaragua",
        label: "🇳🇮 Nicaragua",
    },
    {
        value: "Niger",
        label: "🇳🇪 Niger",
    },
    {
        value: "Nigeria",
        label: "🇳🇬 Nigeria",
    },
    {
        value: "North Korea",
        label: "🇰🇵 North Korea",
    },
    {
        value: "Norway",
        label: "🇳🇴 Norway",
    },
    {
        value: "Oman",
        label: "🇴🇲 Oman",
    },
    {
        value: "Pakistan",
        label: "🇵🇰 Pakistan",
    },
    {
        value: "Palau",
        label: "🇵🇼 Palau",
    },
    {
        value: "Palestine",
        label: "🇵🇸 Palestine",
    },
    {
        value: "Panama",
        label: "🇵🇦 Panama",
    },
    {
        value: "Papua New Guinea",
        label: "🇵🇬 Papua New Guinea",
    },
    {
        value: "Paraguay",
        label: "🇵🇾 Paraguay",
    },
    {
        value: "Peru",
        label: "🇵🇪 Peru",
    },
    {
        value: "Philippines",
        label: "🇵🇭 Philippines",
    },
    {
        value: "Poland",
        label: "🇵🇱 Poland",
    },
    {
        value: "Portugal",
        label: "🇵🇹 Portugal",
    },
    {
        value: "Qatar",
        label: "🇶🇦 Qatar",
    },
    {
        value: "Romania",
        label: "🇷🇴 Romania",
    },
    {
        value: "Russia",
        label: "🇷🇺 Russia",
    },
    {
        value: "Rwanda",
        label: "🇷🇼 Rwanda",
    },
    {
        value: "Saint Kitts and Nevis",
        label: "🇰🇳 Saint Kitts and Nevis",
    },
    {
        value: "Saint Lucia",
        label: "🇱🇨 Saint Lucia",
    },
    {
        value: "Saint Vincent and the Grenadines",
        label: "🇻🇨 Saint Vincent and the Grenadines",
    },
    {
        value: "Samoa",
        label: "🇼🇸 Samoa",
    },
    {
        value: "San Marino",
        label: "🇸🇲 San Marino",
    },
    {
        value: "Sao Tome and Principe",
        label: "🇸🇹 Sao Tome and Principe",
    },
    {
        value: "Saudi Arabia",
        label: "🇸🇦 Saudi Arabia",
    },
    {
        value: "Senegal",
        label: "🇸🇳 Senegal",
    },
    {
        value: "Serbia",
        label: "🇷🇸 Serbia",
    },
    {
        value: "Seychelles",
        label: "🇨🇰 Seychelles",
    },
    {
        value: "Sierra Leone",
        label: "🇸🇱 Sierra Leone",
    },
    {
        value: "Singapore",
        label: "🇸🇬 Singapore",
    },
    {
        value: "Slovakia",
        label: "🇸🇰 Slovakia",
    },
    {
        value: "Slovenia",
        label: "🇸🇮 Slovenia",
    },
    {
        value: "Solomon Islands",
        label: "🇼🇸 Solomon Islands",
    },
    {
        value: "Somalia",
        label: "🇸🇴 Somalia",
    },
    {
        value: "South Africa",
        label: "��🇦 South Africa",
    },
    {
        value: "South Korea",
        label: "🇰🇷 South Korea",
    },
    {
        value: "Spain",
        label: "🇪🇸 Spain",
    },
    {
        value: "Sri Lanka",
        label: "🇱🇰 Sri Lanka",
    },
    {
        value: "Sudan",
        label: "🇸🇩 Sudan",
    },
    {
        value: "Suriname",
        label: "🇸🇷 Suriname",
    },
    {
        value: "Sweden",
        label: "🇸🇪 Sweden",
    },
    {
        value: "Switzerland",
        label: "🇨🇭 Switzerland",
    },
    {
        value: "Syria",
        label: "🇸🇾 Syria",
    },
    {
        value: "Tajikistan",
        label: "🇹🇯 Tajikistan",
    },
    {
        value: "Thailand",
        label: "🇹🇭 Thailand",
    },
    {
        value: "Togo",
        label: "🇹🇬 Togo",
    },
    {
        value: "Tonga",
        label: "🇹🇴 Tonga",
    },
    {
        value: "Trinidad and Tobago",
        label: "🇹🇹 Trinidad and Tobago",
    },
    {
        value: "Tunisia",
        label: "🇹🇳 Tunisia",
    },
    {
        value: "Turkey",
        label: "🇹🇷 Turkey",
    },
    {
        value: "Turkmenistan",
        label: "🇹🇲 Turkmenistan",
    },
    {
        value: "Tuvalu",
        label: "🇻🇺 Tuvalu",
    },
    {
        value: "Uganda",
        label: "🇺🇬 Uganda",
    },
    {
        value: "Ukraine",
        label: "🇺🇦 Ukraine",
    },
    {
        value: "United Arab Emirates",
        label: "🇦🇪 United Arab Emirates",
    },
    {
        value: "United Kingdom",
        label: "🇬🇧 United Kingdom",
    },
    {
        value: "Uruguay",
        label: "🇺🇾 Uruguay",
    },
    {
        value: "Uzbekistan",
        label: "🇺🇿 Uzbekistan",
    },
    {
        value: "Vanuatu",
        label: "🇻🇺 Vanuatu",
    },
    {
        value: "Vatican City",
        label: "🇻🇦 Vatican City",
    },
    {
        value: "Venezuela",
        label: "🇻🇪 Venezuela",
    },
    {
        value: "Vietnam",
        label: "🇻🇳 Vietnam",
    },
    {
        value: "Yemen",
        label: "🇾🇪 Yemen",
    },
    {
        value: "Zambia",
        label: "🇿🇲 Zambia",
    },
    {
        value: "Zimbabwe",
        label: "🇿🇼 Zimbabwe",
    }
]

const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
]

const seatOptions = [
    { value: "window", label: "Window" },
    { value: "aisle", label: "Aisle" },
    { value: "middle", label: "Middle" },
]

const mealOptions = [
    { value: "vegetarian", label: "Vegetarian" },
    { value: "glatt-kosher", label: "Glatt Kosher" },
    { value: "diabetic", label: "Diabetic" },
    { value: "gluten-free", label: "Gluten Free" },
    { value: "lactose-intolerant", label: "Lactose Intolerant" },
    { value: "vegan", label: "Vegan" },
]

const tripTypeOptions = [
    { value: "one-way", label: "One Way", icon: "arrow_forward" },
    { value: "round-trip", label: "Round Trip", icon: "repeat" },
]

const ticketsInventory = [
    {
        // id: 2,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-02-09",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 3,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-02-10",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 4,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-02-11",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 5,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-02-12",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 6,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:55",
        arrivalTime: "10:00 (+1)",
        departureDate: "2025-02-13",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 7,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "23:30",
        arrivalTime: "05:50 (+1)",
        departureDate: "2025-02-15",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 8,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-02-16",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 9,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-02-17",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 10,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-02-18",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 11,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-02-19",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 12,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:55",
        arrivalTime: "10:00 (+1)",
        departureDate: "2025-02-20",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 13,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "23:30",
        arrivalTime: "05:50 (+1)",
        departureDate: "2025-02-22",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 14,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-02-23",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 15,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-02-24",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 16,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-02-25",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 17,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-02-26",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 18,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:55",
        arrivalTime: "10:00 (+1)",
        departureDate: "2025-02-27",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 19,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "23:30",
        arrivalTime: "05:50 (+1)",
        departureDate: "2025-03-01",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 20,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-03-02",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 21,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-03-03",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 22,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-03-04",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 23,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "18:20",
        departureDate: "2025-03-05",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 24,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:55",
        arrivalTime: "10:00 (+1)",
        departureDate: "2025-03-06",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 25,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "23:30",
        arrivalTime: "06:50 (+1)",
        departureDate: "2025-03-08",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 26,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "08:00 (+1)",
        departureDate: "2025-03-09",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 27,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "19:20",
        departureDate: "2025-03-10",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 28,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "08:00 (+1)",
        departureDate: "2025-03-11",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 29,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "19:20",
        departureDate: "2025-03-12",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 30,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "16:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-03-13",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 31,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "23:30",
        arrivalTime: "06:50 (+1)",
        departureDate: "2025-03-15",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 32,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "08:00 (+1)",
        departureDate: "2025-03-16",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 33,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "19:20",
        departureDate: "2025-03-17",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 34,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "08:00 (+1)",
        departureDate: "2025-03-18",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 35,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "19:20",
        departureDate: "2025-03-19",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 36,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "16:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-03-20",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 37,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "23:30",
        arrivalTime: "06:50 (+1)",
        departureDate: "2025-03-22",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 38,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "08:00 (+1)",
        departureDate: "2025-03-23",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 39,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "19:20",
        departureDate: "2025-03-24",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 40,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "08:00 (+1)",
        departureDate: "2025-03-25",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 41,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "19:20",
        departureDate: "2025-03-26",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 42,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "16:00",
        arrivalTime: "09:00 (+1)",
        departureDate: "2025-03-27",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 43,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "23:30",
        arrivalTime: "06:50 (+1)",
        departureDate: "2025-03-29",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 44,
        // departure: "JFK",
        // arrival: "TLV",
        departureTime: "15:00",
        arrivalTime: "08:00 (+1)",
        departureDate: "2025-03-30",
        flightNo: "IZ992",
        availableTickets: 5,
        price: "599.00"
    },
    {
        // id: 45,
        // departure: "TLV",
        // arrival: "JFK",
        departureTime: "12:00",
        arrivalTime: "19:20",
        departureDate: "2025-03-31",
        flightNo: "IZ991",
        availableTickets: 5,
        price: "599.00"
    }
]

export { nationalities, genderOptions, countries, tripTypeOptions, ticketsInventory, seatOptions, mealOptions }